enum EReviewExpNameOptions {
  SCREENNAME = 1,
  DATE,
  TEMPERATURE,
}

export default EReviewExpNameOptions;
